<form *ngIf="form" [formGroup]="form">
	<header>
		<h2 i18n>Для доступа к контейнеру личного ключа введите пароль</h2>
	</header>
	<div class="main">
		<div>
			<b i18n>Логин:</b>
			<app-textbox formControlName="login" isDisabled=true></app-textbox>
		</div>
		<div>
			<b i18n>Пароль:</b>
			<app-passwordbox formControlName="password" name="Пароль" [noTrimValue]="true"></app-passwordbox>
		</div>
	</div>
	<footer>
		<button i18n class="save" appSkin="action-save bold" (click)="confirm(form)">ОК</button>
		<button i18n class="save" appSkin="simple no-shadow bold bordered" (click)="close()">Закрыть</button>
	</footer>
</form>
<app-overlay #notification></app-overlay>